import {Type} from 'class-transformer';

import {LookinChatSDK} from '../lib/lookinChatSDK';

import {User} from './user';

/**
 * Abstract state
 *
 * @category Common entities
 * */
export abstract class State {

  /**
   * State type
   * */
  type: unknown = null;

  // @todo change to null
  /**
   * Date of state on server
   * */
  @Type(() => Date)
  date: Date | string = new Date();

  /**
   * Date of state on client, use this one to take date of change
   * */
  @Type(() => Date)
  dateClient: Date | string = new Date();

  /**
   * Author of state, can be null
   * */
  @Type(() => User)
  user: User = null;

  /**
   * @ignore
   * */
  constructor() {
    if (LookinChatSDK.user) {
      this.user = LookinChatSDK.user;
    }
  }
}

/**
 * Abstract state type
 * */
export type StateType = 'delete' | 'edit' | 'create';
